import React from 'react';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import DieselDataView from '@/components/DieselDataView';

const DieselDataDashboard: React.FC = () => {
  const enabled = useFeatureFlag('freightos-dashboard');

  if (!enabled) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-rs-black">
        <p className="text-rs-off-white/60">This feature is not available.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-rs-black">
      <DieselDataView />
    </div>
  );
};

export default DieselDataDashboard;
